import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import ThemeToggle from "@/components/ThemeToggle";
import SiteFooter from "@/components/SiteFooter";
import TermlyEmbed from "@/components/TermlyEmbed";

const TERMLY_COOKIES_ID = "03a31cd3-edaf-40fa-9635-48a8e6711c7e";

export default function Cookies() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-foreground/30 glass-strong sticky top-0 z-40">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
          <Link to="/"><Logo /></Link>
          <ThemeToggle />
        </div>
      </header>

      <main className="flex-1 max-w-3xl mx-auto px-6 md:px-10 py-16 md:py-24 w-full" data-testid="cookies-page">
        <div className="terminal-label mb-4">[ LEGAL · COOKIES ]</div>
        <div className="legal-body">
          <TermlyEmbed dataId={TERMLY_COOKIES_ID} testid="cookies-termly-embed" />
        </div>
      </main>

      <SiteFooter variant="site" />
    </div>
  );
}
